import React, { Component } from "react";
// @material-ui/core components

import {EmptyRecord} from "../../utils/PageUtility";
import {appHelpers} from "../../_helpers";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import RecordPagination  from "../../utils/RecordsPagination";

const SettingTableStructure = ({filterAirport, classes, records, filterUsers, user,filterAirlines, handleEdit, pageIndex}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell padding="none">S/N</TableCell>
                <TableCell padding="none">Airline</TableCell>
                <TableCell padding="none">Airport</TableCell>
                <TableCell padding="none">Re-order Level</TableCell>
                <TableCell padding="none">Token Re-order Amount (&#8358;)</TableCell>
                {/*<TableCell padding="none">Processed By</TableCell>*/}
                {/*<TableCell padding="none">Status</TableCell>*/}
            </TableRow>
        </TableHead>
        <TableBody>
            {records  && records.map((item, key) => {
                return (
                    <TableRow hover key={pageIndex + key}>
                        <TableCell padding="none" component="th">
                            {pageIndex + key}
                        </TableCell>
                        <TableCell padding="none" className={'text-capitalize'}>{filterAirlines(item.AirlineId)}</TableCell>
                        <TableCell padding="none" className={'text-capitalize'}>{filterAirport(item.AirportCode)}</TableCell>
                        <TableCell padding="none" component="th">
                            {appHelpers.numberWithCommasOnly(item.Token)}
                            {/*{item.Token}*/}
                        </TableCell>
                        <TableCell padding="none" component="th">
                        &#8358; {appHelpers.numberWithCommas(item.Amount)}
                        </TableCell>
                        {/*<TableCell padding="none" component="th">*/}
                            {/*{filterUsers(item.ApprovedBy)}*/}
                        {/*</TableCell>*/}
                        {/*<TableCell padding="none" component="th">*/}
                            {/*{item.IsApproved === true && <span style={{color:"#66bb6a"}}>Approved</span>}*/}
                            {/*{item.IsApproved === false &&<span style={{color:"#dd2735"}}> Declined</span>}*/}
                            {/*{item.IsApproved === null && "Pending"}*/}
                        {/*</TableCell>*/}
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class SettingsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            flight: false
        };
    }

    handleClickOpen = (flight) => {
        this.setState({ open: true });
        this.setState({flight});
        this.props.fetchFlightPassengers(flight.Id);
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const {filterAirport, totalCounts, fetchRecords, pageSize, currentPage, classes, handleEdit, filterUsers, filterAirlines, user, records } = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;

        if(totalCounts === 0)
            return (<EmptyRecord message={'No Minimum Re-order Level yet!'}/>);
        // if(searchError)
        //     return (<EmptyRecord message={searchError}/>);
        return (
            <div>
                <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                    <RecordPagination fetchMore={fetchRecords} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<SettingTableStructure records={records} classes={classes} filterAirport={filterAirport} pageIndex={pageIndex} filterAirlines={filterAirlines} filterUsers={filterUsers} handleEdit={handleEdit} user={user}/>}/>
                </div>
                {/*<div className={classes.tableResponsive} style={{ overflowX: "auto" }}>*/}
                    {/*<SettingTableStructure records={records} classes={classes} filterAirlines={filterAirlines} filterUsers={filterUsers} handleEdit={handleEdit} user={user}/>*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default SettingsTable;



// WEBPACK FOOTER //
// ./src/views/Settings/settingsTable.js